import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import BranchCalendar from '../components/BranchCalendar';
import WorkCalendar from '../components/WorkCalendar';

const CalendarPage = () => {
  const { user, hasRole } = useAuth();

  // Admin/Manager see the branch calendar (work assignments and leave management)
  // if (hasRole(['admin', 'store_manager'])) {
  //   return <BranchCalendar />;
  // }

  // Regular employees see their work calendar (personal schedule)
  return <WorkCalendar />;
};

export default CalendarPage;